import { OverlayProps } from '@allesauto/core/overlay';
import { SupportedCurrencies, SupportedLocales } from '@allesauto/utils/consts';

import { IReduxActionProps } from './../../Utils/index';
export const LOCALE_CHANGED = 'LOCALE_CHANGED';

export const SET_CURRENCY = 'SET_CURRENCY';
export const OPEN_OVERLAY = 'OPEN_OVERLAY';
export const CLOSE_OVERLAY = 'CLOSE_OVERLAY';
export const SET_OVERLAY_LOADING_STATE = 'SET_OVERLAY_LOADING_STATE';
export const UPDATE_OVERLAY_PROPS = 'UPDATE_OVERLAY_PROPS';

export const SHOW_CART_NOTIFICATION = 'SHOW_CART_NOTIFICATION';
export const HIDE_CART_NOTIFICATION = 'HIDE_CART_NOTIFICATION';

export const changeLocale = (locale: SupportedLocales): IReduxActionProps => {
  return {
    type: LOCALE_CHANGED,
    payload: {
      locale,
    },
  };
};

type OverlayPropsPayload = Omit<
  OverlayProps,
  'open' | 'onClose' | 'whiteLabelIntegrationSlug'
>;

export const openOverlay = (props: OverlayPropsPayload): IReduxActionProps => {
  return {
    type: OPEN_OVERLAY,
    payload: props,
  };
};

export const closeOverlay = (): IReduxActionProps => {
  return {
    type: CLOSE_OVERLAY,
  };
};

// todo: remove this function and replace it with the generic one below - updateOverlayProps
export const setOverlayLoadingState = (
  loadingState: boolean
): IReduxActionProps => {
  return {
    type: SET_OVERLAY_LOADING_STATE,
    payload: {
      loadingState,
    },
  };
};

export const updateOverlayProps = (
  props: OverlayPropsPayload
): IReduxActionProps => {
  return {
    type: UPDATE_OVERLAY_PROPS,
    payload: props,
  };
};

export const showCartNotification = (): IReduxActionProps => {
  return {
    type: SHOW_CART_NOTIFICATION,
  };
};

export const hideCartNotification = (): IReduxActionProps => {
  return {
    type: HIDE_CART_NOTIFICATION,
  };
};

export const setCurrency = (
  currency: SupportedCurrencies
): IReduxActionProps => {
  return {
    type: SET_CURRENCY,
    payload: {
      currency,
    },
  };
};
